import Toast from 'react-native-toast-message';
import { translate } from '../../services/translate';
import { documentService } from '../../services/central-api/document';

export async function downloadTermsVersion(termsId: number, version: number) {
    try {
        const { blob, fileName } = await documentService.downloadTermsOfUseAndPrivacyVersion(termsId, version);

        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(url);
    } catch (err) {
        console.error(err);
        Toast.show({ type: 'sentinelxError', text1: translate('unexpectedError') });
    }
}
